

(function(){
  function setReadmore(btn, target, open){
    target.setAttribute('data-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? 'Show Less' : 'Show More';
    if(open){ target.style.maxHeight = target.scrollHeight + 'px'; }
    else { target.style.maxHeight = target.scrollHeight + 'px'; target.getBoundingClientRect(); target.style.maxHeight = '0px'; }
  }

  function initReadmores(scope){
    scope.querySelectorAll('.fa-linkbtn[aria-controls]').forEach(function(btn){
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if(!target) return; setReadmore(btn, target, false);
      btn.addEventListener('click', function(){ var willOpen = btn.getAttribute('aria-expanded') !== 'true'; setReadmore(btn, target, willOpen); });
    });
  }

  function initTabs(scope){
    scope.querySelectorAll('[role="tablist"]').forEach(function(list){
      var tabs = Array.from(list.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function(t){ return document.getElementById(t.getAttribute('aria-controls')); });
      function activate(i){
        tabs.forEach(function(t,j){ t.setAttribute('aria-selected', j===i ? 'true':'false'); t.tabIndex = j===i?0:-1; });
        panels.forEach(function(p,j){ if(!p) return; p.dataset.active = (j===i ? 'true':'false'); });
      }
      tabs.forEach(function(t,i){ t.addEventListener('click', function(){ activate(i); }); });
      // init first active
      activate(0);
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initTabs(document);
    initReadmores(document);
  });
})();

